(()=>{
const URL3D='https://cdn.shopify.com/3d/models/687fa6dff83d1ff6/AXION_PS5_builder_3d_OEM_material-linked-v1.glb';
const M={
  shell:['AXION_SHELL__VRayMtl55','AXION_SHELL__front_body'],
  face:['AXION_FACE__Material.002','AXION_FACE_BODY__SOLID'],
  dpad:['AXION_DPAD__Material.002','AXION_DPAD__Material.009','AXION_DPAD__material_0'],
  share:['AXION_SMALL__Material.007'],
  sticks:['AXION_STICKS__VRayMtl33'],
  rings:['AXION_RINGS__front_body.002'],
  touch:['AXION_TOUCHPAD__front_body'],
  ps:['AXION_SMALL__Material.005'],
  mic:['AXION_SMALL__Material'],
  bumpers:['AXION_BUMPERS__VRayMtl37'],
  triggers:['AXION_TRIGGERS__VRayMtl37']
};
const OEM_SHELL={
  'Chroma Indigo':{color:'#3b3592',metallic:.42,roughness:.14},
  'Chroma Pearl':{color:'#eef1f5',metallic:.42,roughness:.14},
  Black:{color:'#111720',metallic:0,roughness:.50},
  'Volcano Red':{color:'#b4112c',metallic:0,roughness:.42},
  White:{color:'#e9e9e6',metallic:0,roughness:.46},
  'Starlight Blue':{color:'#42a6dc',metallic:0,roughness:.42},
  'Sterling Silver':{color:'#9da8b7',metallic:0,roughness:.40},
  'Cosmic Red':{color:'#a31c49',metallic:0,roughness:.42},
  'Galactic Purple':{color:'#542db2',metallic:0,roughness:.42},
  'Grey Camouflage':{color:'#666b70',metallic:0,roughness:.50},
  'Techno Red':{color:'#e4322b',metallic:0,roughness:.42},
  'Remix Green':{color:'#28b783',metallic:0,roughness:.42},
  'Rhythm Blue':{color:'#1587d4',metallic:0,roughness:.42}
};
const SC=Object.fromEntries(Object.entries(OEM_SHELL).map(([name,style])=>[name,style.color]));
const OEM_DARK='#111720';
const OEM_COMPONENTS={
  'Chroma Indigo':{frame:'#27223e',controls:'#332b52',touch:'#3b3592',sticks:'#332b52',rings:'#332b52',bumpers:'#332b52',triggers:'#332b52',ps:'#332b52',mic:'#332b52'},
  'Chroma Pearl':{frame:'#dce2eb',controls:'#eef1f5',touch:'#f0f1f6',sticks:'#e1e5ec',rings:'#d9dee8',bumpers:'#e7eaf0',triggers:'#e7eaf0',ps:'#dce2eb',mic:'#dce2eb'}
};
const C={Bianco:'#f3f1ea',Nero:'#101215',Rosso:'#dc2f37',Blu:'#145bd7',Verde:'#4ccf4f',Giallo:'#f0e31c','Baby Blu':'#45cfff',Rosa:'#ff39c7',Arancione:'#ef842d',Viola:'#804db6',Grigio:'#797d85'};
const OEM_SYMBOLS={Black:'#97999f',White:'#9299a8','Chroma Indigo':'#9bdff2','Chroma Pearl':'#9899b5','Cosmic Red':'#e888a2','Galactic Purple':'#aaa0de','Starlight Blue':'#748da8','Sterling Silver':'#e8edf4','Volcano Red':'#f2e5e0','Techno Red':'#f2e5e0','Remix Green':'#b6e0c6','Rhythm Blue':'#a4d9ed','Grey Camouflage':'#aeb6bd'};
const OEM_BLACK=[0,0,0,1];
const K=Object.keys(M).filter(k=>k!=='shell');
const EDIT_AESTHETIC_LABELS={
  face:'Bottoni Frontali',dpad:'Frecce Direzionali',share:'Options & Share',sticks:'Analogici',rings:'Anelli Analogici',
  touch:'Touchpad',ps:'Bottone PS',mic:'Microfono',bumpers:'Bumpers',triggers:'Triggers'
};
const isCustom=value=>String(value||'').toLowerCase().includes('personalizzat');
const lin=v=>{v/=255;return v<=0.04045?v/12.92:Math.pow((v+0.055)/1.055,2.4)};
const rgba=h=>{const s=h.replace('#','');return [lin(parseInt(s.slice(0,2),16)),lin(parseInt(s.slice(2,4),16)),lin(parseInt(s.slice(4,6),16)),1]};
document.querySelectorAll('[data-axion-configurator][data-product-handle="axion-designer-ps5"]').forEach(root=>{
  if(root.dataset.axionWebMasterV1==='1')return;root.dataset.axionWebMasterV1='1';
  const stage=root.querySelector('[data-stage]'),v=root.querySelector('[data-axion-model-viewer]'),status=root.querySelector('[data-axion-model-status]'),modes=[...root.querySelectorAll('[data-axion-mode]')],views=root.querySelector('[data-axion-photo-controls]');
  if(!stage||!v)return;
  root.querySelector('[data-axion-preview-mode]')?.remove();

  let ready=false,mode='3d',orig=new Map(),psSurfaceOrig=new Map();
  const editPayload=root.__axionEditPayload&&typeof root.__axionEditPayload==='object'?root.__axionEditPayload:null;
  const editChoices=editPayload?.aesthetic&&typeof editPayload.aesthetic==='object'?editPayload.aesthetic:{};
  const editHasCustom=isCustom(editPayload?.aestheticMode)||Object.values(editChoices).some(choice=>isCustom(choice?.mode));
  const state={
    shell:String(editPayload?.shell||root.querySelector('[data-shell-name]')?.textContent?.trim()||'Black'),
    aMode:editHasCustom?'Colori Personalizzati':'Standard',
    rear:{buttons:Number(editPayload?.rear?.buttons||0),position:String(editPayload?.rear?.position||''),color:String(editPayload?.rear?.coverColor||'Nero')},
    a:Object.fromEntries(K.map(key=>{
      const choice=editChoices[EDIT_AESTHETIC_LABELS[key]];
      return [key,{mode:isCustom(choice?.mode)?'Colori Personalizzati':'Standard',color:String(choice?.color||'Bianco')}];
    }))
  };
  const say=(t,ok=false)=>{if(status){status.textContent=t;status.classList.toggle('is-ready',ok)}};
  const materials=()=>v.model?.materials||[];
  const mat=n=>materials().find(x=>x.name===n);
  const set=(names,color)=>{if(!ready)return;const factor=Array.isArray(color)?color:rgba(color);names.forEach(n=>mat(n)?.pbrMetallicRoughness?.setBaseColorFactor(factor))};
  const styleShell=()=>{
    const style=OEM_SHELL[state.shell]||OEM_SHELL.Black;
    M.shell.forEach(name=>{
      const pbr=mat(name)?.pbrMetallicRoughness;
      if(!pbr)return;
      pbr.setBaseColorFactor(rgba(style.color));
      pbr.setMetallicFactor?.(style.metallic);
      pbr.setRoughnessFactor?.(style.roughness);
    });
  };
  const applyOemParts=()=>{
    const shell=OEM_SHELL[state.shell]||OEM_SHELL.Black;
    const special=OEM_COMPONENTS[state.shell];
    const controls=special?.controls||shell.color;
    const frame=special?.frame||OEM_DARK;
    set(['AXION_FRAME__front_body.001'],frame);
    set(M.face,controls);
    set(M.dpad,controls);
    set(M.share,controls);
    set(M.touch,special?.touch||shell.color);
    M.touch.forEach(name=>{
      const pbr=mat(name)?.pbrMetallicRoughness;
      if(!pbr)return;
      pbr.setMetallicFactor?.(shell.metallic);
      pbr.setRoughnessFactor?.(shell.roughness);
    });
    set(M.sticks,special?.sticks||OEM_DARK);
    set(M.rings,special?.rings||OEM_DARK);
    set(M.bumpers,special?.bumpers||OEM_DARK);
    set(M.triggers,special?.triggers||OEM_DARK);
    set(M.ps,special?.ps||OEM_DARK);
    set(M.mic,'#30353a');
    M.mic.forEach(name=>{
      const pbr=mat(name)?.pbrMetallicRoughness;
      if(!pbr)return;
      pbr.setMetallicFactor?.(0);
      pbr.setRoughnessFactor?.(.42);
    });
  };
  const restore=names=>names.forEach(n=>{const f=orig.get(n);if(f)set([n],f)});
  const psLogoMaterials=()=>materials().filter(x=>x.name==='Material.006'||x.name.endsWith('__Material.006')||/PS.*LOGO/i.test(x.name));
  const stylePsLogo=hidden=>psLogoMaterials().forEach(material=>{
    material.setAlphaMode?.(hidden?'BLEND':'OPAQUE');
    material.pbrMetallicRoughness?.setBaseColorFactor(hidden?[0,0,0,0]:OEM_BLACK);
    material.pbrMetallicRoughness?.setMetallicFactor?.(0);
    material.pbrMetallicRoughness?.setRoughnessFactor?.(.22);
  });
  const cachePsSurface=()=>M.ps.forEach(name=>{
    const material=mat(name),pbr=material?.pbrMetallicRoughness;
    if(!material||psSurfaceOrig.has(name))return;
    psSurfaceOrig.set(name,{
      base:pbr?.baseColorTexture?.texture||null,
      metallicRoughness:pbr?.metallicRoughnessTexture?.texture||null,
      normal:material.normalTexture?.texture||null,
      occlusion:material.occlusionTexture?.texture||null,
      emissive:material.emissiveTexture?.texture||null,
      metallic:pbr?.metallicFactor,
      roughness:pbr?.roughnessFactor
    });
  });
  const stylePsButton=(custom,color)=>{
    cachePsSurface();
    M.ps.forEach(name=>{
      const material=mat(name),pbr=material?.pbrMetallicRoughness,original=psSurfaceOrig.get(name);
      if(!material||!pbr)return;
      pbr.baseColorTexture?.setTexture?.(custom?null:original?.base||null);
      pbr.metallicRoughnessTexture?.setTexture?.(custom?null:original?.metallicRoughness||null);
      material.normalTexture?.setTexture?.(custom?null:original?.normal||null);
      material.occlusionTexture?.setTexture?.(custom?null:original?.occlusion||null);
      material.emissiveTexture?.setTexture?.(custom?null:original?.emissive||null);
      if(custom){
        pbr.setBaseColorFactor(C[color]||C.Nero);
        pbr.setMetallicFactor?.(0);
        pbr.setRoughnessFactor?.(.68);
        material.setEmissiveFactor?.([0,0,0]);
      }else{
        if(original?.metallic!=null)pbr.setMetallicFactor?.(original.metallic);
        if(original?.roughness!=null)pbr.setRoughnessFactor?.(original.roughness);
      }
    });
  };
  const syncSymbols=()=>{
    materials().filter(x=>/^AXION_(FACE|DPAD)_SYMBOL__/.test(x.name)).forEach(material=>{
      const key=material.name.startsWith('AXION_FACE_')?'face':'dpad';
      const custom=state.aMode==='Colori Personalizzati'&&state.a[key]?.mode==='Colori Personalizzati';
      material.setAlphaMode?.(custom?'BLEND':'OPAQUE');
      material.pbrMetallicRoughness?.setBaseColorFactor(custom?[0,0,0,0]:rgba(OEM_SYMBOLS[state.shell]||OEM_SYMBOLS.Black));
      material.pbrMetallicRoughness?.setRoughnessFactor?.(custom?.33:.55);
    });
  };

  function read(){
    state.shell=root.querySelector('[data-shell-name]')?.textContent?.trim()||state.shell;
    const current=root.__axionCurrentBuild?.().payload?.rear;
    if(current)state.rear={buttons:Number(current.buttons||0),position:String(current.position||''),color:String(current.coverColor||'Nero')};
    const gm=root.querySelector('[data-action="set"][data-key="aestheticMode"].is-selected')?.dataset.value;
    if(gm)state.aMode=gm;
    K.forEach(k=>{
      const m=root.querySelector(`[data-action="a-mode"][data-key="${k}"].is-selected`)?.dataset.value;
      const c=root.querySelector(`[data-action="a-color"][data-key="${k}"].is-selected`)?.dataset.value;
      if(m)state.a[k].mode=m;if(c)state.a[k].color=c;
    });
  }
  function syncCustom(){
    if(!ready)return;
    styleShell();
    applyOemParts();
    syncSymbols();
    if(state.aMode!=='Colori Personalizzati')return;
    K.forEach(k=>{
      const x=state.a[k];
      if(x?.mode!=='Colori Personalizzati')return;

      if(k==='ps'){
        set(['AXION_PS_MOUNT__BLACK'],OEM_BLACK);
        stylePsButton(true,x.color);
        stylePsLogo(true);
        return;
      }
      set(M[k],C[x.color]||C.Bianco);
    });
  }
  let lastMaterialState='';
  function sync(){
    if(!ready)return;
    const materialState=JSON.stringify(state);
    if(materialState===lastMaterialState)return;
    set(M.shell,SC[state.shell]||SC.Black);
    styleShell();
    applyOemParts();

    // Standard follows the complete OEM palette for the selected shell.
    // Custom choices override only the component selected by the customer.
    const ps=state.a.ps;
    const psCustom=state.aMode==='Colori Personalizzati'&&ps?.mode==='Colori Personalizzati';
    set(['AXION_PS_MOUNT__BLACK'],OEM_BLACK);
    if(psCustom){
      stylePsButton(true,ps.color);
      stylePsLogo(true);
    }else{
      stylePsButton(false);
      stylePsLogo(false);
    }

    K.forEach(k=>{
      if(k==='ps')return;
      const x=state.a[k];
      if(state.aMode==='Colori Personalizzati'&&x.mode==='Colori Personalizzati')set(M[k],C[x.color]||C.Bianco);
    });
    syncSymbols();
    const positions=state.rear.buttons===2?[state.rear.position]:state.rear.buttons===4?state.rear.position.split(' - '):[];
    ['Medium','Standard','Busters','Low','Lower'].forEach(position=>{
      ['L','R'].forEach(side=>{
        const name=`AXION_REAR__A29_${side}_${position}`;
        const material=mat(name),selected=positions.includes(position)||position==='Busters'&&positions.includes("Buster's");
        if(material){material.setAlphaMode?.(selected?'OPAQUE':'BLEND');material.pbrMetallicRoughness?.setBaseColorFactor(selected?rgba(C[state.rear.color]||C.Nero):[0,0,0,0])}
      });
    });
    lastMaterialState=materialState;
  }
  root.__axionSyncCustomMaterials=()=>{read();syncCustom()};

  // Camera motion is owned exclusively by axion-configurator-v5.9-grey-camouflage.js.
  // This loader only handles the model/materials and never writes camera-orbit/target.
  function setMode(){
    mode='3d';stage.classList.add('is-axion-3d');
    modes.forEach(b=>b.classList.toggle('is-active',b.dataset.axionMode==='3d'));
    if(views)views.hidden=false;
  }

  root.addEventListener('click',event=>{if(event.target.closest('.axv3__devcart-add'))return;queueMicrotask(()=>{read();sync()})},true);
  root.addEventListener('change',()=>queueMicrotask(()=>{read();sync()}),true);
  const shell=root.querySelector('[data-shell-name]');if(shell)new MutationObserver(()=>{read();sync()}).observe(shell,{childList:true,subtree:true,characterData:true});

  v.addEventListener('load',()=>{
    ready=true;orig.clear();psSurfaceOrig.clear();lastMaterialState='';
    v.model?.materials?.forEach(x=>{if(x.isLoaded===false)return;const f=x.pbrMetallicRoughness?.baseColorFactor;if(f?.length===4)orig.set(x.name,[...f])});
    cachePsSurface();
    const sticks=mat('AXION_STICKS__VRayMtl33')?.pbrMetallicRoughness;
    sticks?.setMetallicFactor?.(0);
    sticks?.setRoughnessFactor?.(.78);
    read();sync();
    root.dataset.axionWebMasterV1Ready='1';say('3D LIVE · WEB MASTER V1.2.3 · OEM RESTORED',true);
  });
  v.addEventListener('error',e=>{console.error('[AXION WEB MASTER V1.2]',e);ready=false;say('3D NON DISPONIBILE');setMode()});

  (async()=>{try{
    say('3D LIVE · caricamento AXION PS5…');
    await Promise.race([customElements.whenDefined('model-viewer'),new Promise((_,rej)=>setTimeout(()=>rej(Error('model-viewer timeout')),12000))]);
    v.setAttribute('camera-controls','');
    v.setAttribute('disable-pan','');
    v.removeAttribute('disable-zoom');
    v.setAttribute('min-camera-orbit','auto 45deg auto');v.setAttribute('max-camera-orbit','auto 115deg auto');v.setAttribute('field-of-view','27deg');
    v.setAttribute('exposure','1');v.setAttribute('shadow-intensity','.8');v.setAttribute('shadow-softness','.9');
    v.src=URL3D;setMode();
  }catch(e){console.error('[AXION WEB MASTER V1.2 loader]',e);ready=false;say('3D NON DISPONIBILE');setMode()}})();
});
})();




